<template>
  <div>
    <div class="select_area block">
      <el-row>
        <el-col :span="8">
          <span class="item_title">请选择地区：</span>
          <div style="width: 100%">
            <up-cascader ref="hospital" v-model="hosSelectedArea" :filterable="true"  :remote="false" :props="{multiple: true}"  :clearable="true"
                         :options="areaOptions"  @change="handleChangeArea" :maxCount="2"
                         :myClass=" type== 1 ? 'hos-area-tags' : 'hos-area-tags2'"
                         :class=" type== 1 ? 'hos-area-tags' : 'hos-area-tags2'" placeholder="请选择地区" />
            <!--            <el-cascader collapse-tags class="cascader" ref="cascader"  :options="options" :props="props" clearable v-model="selectedArea" @change="handleChangeArea"></el-cascader>-->
          </div>
        </el-col>
        <el-col :span="8">
          <span class="item_title">请选择医院：</span>
          <div class="choose_distribute">
<!--            <upMultipleSelect ref="selectHospital" v-model="hospital_selected" :filterable="true"  :remote="true" :multiple="true" :remote-method="hosRemoteMethod"  :clearable="true"-->
<!--                              :options="hospitalOptions"  @change="handle_change_hospital" :maxCount="2" :myClass="'select-hospname-tags'"-->
<!--                              class="select-hospname-tags" placeholder="请输入医院名称" />-->

            <el-select
                multiple
                v-model="hospital_selected"
                placeholder="请输入医院名称"
                class="custom-select"
                size="small"
                filterable
                clearable
                remote
                collapse-tags
                :remote-method="handleSearch"
                @change="handle_change_hospital"
                :loading="searchLoading"
            >
              <el-option
                  v-for="item in hospitalOptions"
                  :key="item.hospital"
                  :disabled="item.disabled"
                  :label="item.hospital_full_name"
                  :value="{label:item.hospital_full_name,value:item.hospital,
                  province_id: item.province.value,provinceName: item.province.label,city_id:item.city.value,
                  cityName: item.city.label,customerId:item.customer}"
              ></el-option>
            </el-select>
            <div class="block" v-if="hosSelectedArea.length > 0 " style="margin-top: 10px">
              <el-checkbox v-model="checkedAll" @change="handle_select_all()">全部医院</el-checkbox>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="result_area block">
      <div>
        <div class="left" style="display: inline-block;width: 50%;">
          <span class="item_title">已选择医院：</span>
          <el-checkbox v-model="checkedAllSelected" @change="handle_del_select_all()">全选</el-checkbox>
          <el-button @click="handle_delete()" size="mini" style="margin-left: 14px;background: #BD3124;color: #fff;border:none;">全部删除</el-button>
        </div>
        <div style="display: inline-block;width: 50%;text-align: right">
          <el-input v-model="key_word" size="mini" placeholder="请输入关键字" style="display: inline-block;width: 170px"></el-input>
          <el-button size="mini" @click="handle_filter" style="vertical-align: top;margin-left: 14px;background: #0052D9;color: #fff;">查找</el-button>
        </div>
      </div>
      <div  class="tag_list">
        <span v-for="item in hosDisplayList" style="display: block" :key="item.value">
          <span style="margin-right: 14px;font-weight: bold;">{{item.area_name}}:</span>
          <el-tag
              v-for="tag in item.hospital_list"
              class="item_tag"
              :class="{ 'active-class': tag.isActive,}"
              effect="dark"
              @close="handleClose(tag)"
              closable>
            {{tag.label}}
          </el-tag>
        </span>
      </div>
    </div>
    <el-dialog
        title=""
        :visible.sync="hos_dialogVisible"
        :modal="false"
        :modal-append-to-body="false"
        width="30%"
        :before-close="handleCloseConfirm">
      <span>删除后不可恢复，确认要删除吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="hos_dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmDeleteAll" style="background: #0052D9">确定删除</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api/manage";
import upMultipleSelect from "@/components/upMultipleSelect.vue";
import upCascader from "@/components/upCascader.vue";
import { hospitals_list } from '@/api/search.js'
import {debounce} from "lodash";
export default {
  components: {upMultipleSelect,upCascader},
  props:{
    hospitalDataInfo:{
      type: Array,
      default: () => []
    },
    type: {
      type: Number,
      default: 1
    },
  },
  data() {
    return {
      searchLoading:false,
      key_word: '',
      checkedAll: false,
      checkedAllSelected: false,
      selectSubmitList:[], //选中提交的list
      displayList:[], //展示的list
      hosSelectedArea: [],
      hosSelectedProvinceVal: [],
      hosSelectedCityVal: [],
      selectedValues: [], // 选中的经销商
      hospital_selected: [],
      props: { multiple: true },
      checked: false,
      hospitalOptions:[],
      areaOptions: [],
      salesList: [],
      hos_dialogVisible:false,
      hosSelectOriginList: [], //选中的原始数据，可能不是展示数据，但是提交的原始数据
      hosSelectOriginListTemp: [], //选中的要展示的原始数据，主要为了区分筛选后的数据
      hosDisplayList: [], // 处理过最终展示的选中数据（可能是筛选过的，但不是提交的数据）
      hosSelectSubmitList: {}, //处理过最终的提交数据
      allHospitalLength: 0,
    };
  },
  watch: {
    hospitalDataInfo(val){
      if(val){
        this.initData()
      }
    }
  },
  mounted() {
    let originData = JSON.parse(localStorage.getItem('province'));
    originData.forEach((item) => {
      if(item.city_list && item.city_list.length >0 ){
        item.children = []
        item.children = item.children.concat(item.city_list)
      }
    })
    this.areaOptions = originData
    setTimeout(()=>{
    },300)
  },
  methods: {
    initData(){
      if(this.hospitalDataInfo.length >0){
        let hospitalDataInfoTemp = this.hospitalDataInfo
        hospitalDataInfoTemp.forEach((item) => {
          item.label = item.hospital_full_name
          item.value = item.hospital_id
          item.provinceName = item.province_name
          item.province_id = item.province_id
          item.cityName = item.city_name
          item.city_id = item.city_id
          item.customerId = item.customer_id
        })
        // console.log('hospitalDataInfoTemp123==',hospitalDataInfoTemp)
        this.hosSelectOriginList = hospitalDataInfoTemp
        this.hosSelectOriginListTemp = hospitalDataInfoTemp
        this.rebuildDisplayData()
        this.rebuildSubmitData()
      }
    },
    rebuildDisplayData(){
      const result = [];
      const cityMap = {};
      console.log('this.hosSelectOriginListTemp==',this.hosSelectOriginListTemp)
      this.hosSelectOriginListTemp.forEach(item => {
        const {  cityName, city_id, province_id, provinceName, ...hospitalInfo } = item;
        const area_name = `${provinceName}/${cityName ? cityName : '-'}`;
        const cityKey = `${city_id}`; // 使用城市和city_id作为唯一键（尽管city和city_id在这个例子中总是相同）
        if (!cityMap[cityKey]) {
          cityMap[cityKey] = {

            cityName,
            city_id,
            area_name,
            province_id,
            provinceName,
            hospital_list: []
          };
          result.push(cityMap[cityKey]);
        }

        const cityObj = cityMap[cityKey];
        // 删除医院信息中的重复字段（如customer_id和value，它们已经包含在hospitalInfo中）
        // 但为了保持与所需结构一致，这里我们直接展开hospitalInfo
        cityObj.hospital_list.push(hospitalInfo);
      });

// 由于city_id在第三个对象中可能是错误的（应该是174而不是173），但为保持与输入一致，结果将反映这一错误
// 如果需要修正，请确保输入数据中的city_id是正确的
      this.hosDisplayList = result;
    },
    rebuildSubmitData(){
      const areaData = [];
      const hospitalIds = [];
      const provinceMap = new Map();
      console.log('this.hosSelectOriginList==',this.hosSelectOriginList)
      this.hosSelectOriginList.forEach(item => {
        const { province_id, city_id, value } = item;
        // 将value添加到customerIds数组中
        hospitalIds.push(value);
        if (!provinceMap.has(province_id)) {
          // 如果provinceMap中还没有这个provinceId，则创建一个新的对象并添加到areaData数组中
          areaData.push({
            province_id: province_id,
            city: []
          });
          provinceMap.set(province_id, areaData[areaData.length - 1]);
        }

        // 将city添加到对应provinceId的city数组中
        const provinceInfo = provinceMap.get(province_id);
        if (provinceInfo.city && !provinceInfo.city.includes(city_id)) { // 避免重复添加相同的city
          provinceInfo.city.push(city_id);
        }
      });
      let customer_ids = this.hosSelectOriginList.map(item => {return  item.customerId});
      this.hospital_permission=  {
        area_data: areaData,
        customer_ids,
        hospital_ids: [...new Set(hospitalIds)] // 使用Set去重，然后转换回数组
      }
      // 输出结果以验证
      // console.log('提交的hospital_permission:', this.hospital_permission);
      this.hosSelectSubmitList = this.hospital_permission
    },
    handleChangeArea(value, selectedData) { // 下拉选择区域
      if(value.length > 0){
        this.hosSelectedProvinceVal = this.hosSelectedArea.map(subArray => subArray[0]);
        this.hosSelectedCityVal = this.hosSelectedArea.map(subArray => subArray[1]);
      }else{
        this.hosSelectedProvinceVal = []
        this.hosSelectedCityVal = []
        this.checkedAll =  false
      }
    },
    handle_select_all(){
      if(this.checkedAll){
        this. hosRemoteMethod('','all')
      }
    },
    // 防抖处理后的搜索方法
    handleSearch: debounce(function(event) {
      const keyword = event;
      console.log('handleSearch-keyword==', keyword)
      if(this.hosSelectedProvinceVal.length > 0 || this.hosSelectedCityVal.length > 0 || keyword){
        this.hosRemoteMethod(keyword); // 实际搜索逻辑
      }
    }, 1500),
    hosRemoteMethod(e,type) { //远程搜索医院
      // this.hospitalOptions = hospitals_list({ hospital_name: e })

      this.searchLoading = true
      this.hosSelectedProvinceVal = [...new Set(this.hosSelectedProvinceVal)]
      let params = {
        type:'hospital',
        province_id: this.hosSelectedProvinceVal.toString(),
        city_id: this.hosSelectedCityVal.toString(),
        hospital_name: e
      }
      console.log('远程搜索的参数e==',e)

      api.system_search_data(params).then(res=>{
        this.hospitalOptions = res.data
        this.searchLoading = false
        const existIds = new Set(
            this.hosSelectOriginList.map(item => item.value)
        );
        this.hospitalOptions.forEach(i => {
          i.disabled = existIds.has(i.hospital);
        });

        if(type == 'all'){ // 全选
          let resData = res.data
         console.log('all-options-===', this.hospitalOptions)
          this.allHospitalLength = resData.length
          resData.forEach((item) => {
            item.label = item.hospital_full_name
            item.value = item.hospital
            item.provinceName = item.province.label
            item.province_id = item.province.value
            item.cityName = item.city.label
            item.city_id = item.city.value
            item.customerId = item.customer_id
          })
          this.hospital_selected  =  resData
          this.hosSelectOriginList = this.hosSelectOriginList.concat(resData)
          this.hosSelectOriginListTemp = this.hosSelectOriginListTemp.concat(resData)
          this.hospital_selected = Array.from(new Map(this.hospital_selected.map(item => [item.value, item]))).map(item => item[1])
          this.hosSelectOriginList = Array.from(new Map(this.hosSelectOriginList.map(item => [item.value, item]))).map(item => item[1]) ;
          this.hosSelectOriginListTemp = Array.from(new Map(this.hosSelectOriginListTemp.map(item => [item.value, item]))).map(item => item[1]) ;
          this.rebuildDisplayData()
          this.rebuildSubmitData()
          console.log('this.hospitalOptionseee222====',this.hospitalOptions)
        }
      }).finally(() => {
        this.searchLoading = false
      })

      console.log('this.hospitalOptionseee====',this.hospitalOptions)
    },
    handle_change_hospital(e){ // 下拉选中某个医院

      console.log('下拉选中某个医院===',e)
      this.hosSelectOriginList = this.hosSelectOriginList.concat(e)
      this.hosSelectOriginListTemp = this.hosSelectOriginListTemp.concat(e)
      this.hospital_selected = Array.from(new Map(this.hospital_selected.map(item => [item.value, item]))).map(item => item[1])
      this.hosSelectOriginList = Array.from(new Map(this.hosSelectOriginList.map(item => [item.value, item]))).map(item => item[1]) ;
      this.hosSelectOriginListTemp = Array.from(new Map(this.hosSelectOriginListTemp.map(item => [item.value, item]))).map(item => item[1]) ;
      this.rebuildDisplayData()
      this.rebuildSubmitData()

    },
    handleClose(tag) { // 删除某一个医院
      console.log('tag===',tag)
      this.hosSelectOriginListTemp = this.hosSelectOriginListTemp.filter(item => item.value !== tag.value)
      this.hosSelectOriginList = this.hosSelectOriginList.filter(item => item.value !== tag.value)
      console.log('this.hosDisplayList==',this.hosDisplayList)
      this.hosDisplayList.forEach((item,index) =>{
        item.hospital_list.forEach((i,index)=>{
          // if(i.value === tag.value){
          //   item.hospital_list.splice(index, 1)
          // }
          if(item.hospital_list.length == 0){
            this.hosDisplayList.splice(index, 1)
          }
        })
      })
      this.rebuildDisplayData()
      this.rebuildSubmitData()
      this.hospital_selected = this.hospital_selected.filter(item => item.value !== tag.value)
      if(this.hospital_selected.length < this.allHospitalLength){
        this.checkedAll = false
      }
      this.hospitalOptions.forEach( item=>{
        if(item.value == tag.value){
          item.disabled = false
        }
      })
    },
    handle_del_select_all(e){ //选择某地区下的所有的经医院添加选中样式
      // console.log('checkedAllSelected===',this.checkedAllSelected)
      if(this.checkedAllSelected){
        this.hosDisplayList.forEach(item =>{
          item.hospital_list.forEach(i=>{
            i.isActive = true
          })
        })
      }else{
        this.hosDisplayList.forEach(item =>{
          item.hospital_list.forEach(i=>{
            i.isActive = false
          })
        })
      }
    },
    handle_delete(){
      this.hos_dialogVisible = true
    },
    confirmDeleteAll(){
      this.handle_delete_all()
      this.hos_dialogVisible = false
    },
    handle_delete_all(){ // 删除展示区域选中的所有的经销商
      if(this.key_word){
        const array1 = this.hosSelectOriginList
        const array2 = this.hosSelectOriginListTemp
        this.hosSelectOriginList = array1.filter(item1 =>
            !array2.some(item2 => item2.value == item1.value)
        );
      }else{
        this.hosSelectOriginList = []
      }
      this.hosSelectOriginListTemp = []
      this.hospital_selected = this.hosSelectOriginList
      // console.log('this.selectSubmitList==',this.selectSubmitList)
      this.checkedAllSelected = false
      this.rebuildDisplayData()
      this.rebuildSubmitData()
    },
    handle_filter(){ // 筛选
      // const array = this.selectSubmitList
      // this.displayList = array.filter(item => item.label.includes(this.key_word));
      this.hosSelectOriginListTemp =  this.hosSelectOriginList.filter(item => item.label.includes(this.key_word))
      this.rebuildDisplayData()
    },
    handleCloseConfirm(){
      this.hos_dialogVisible = false
    }
  }
};
</script>
<style scoped lang="scss">
.block{
  display: block;
  .item_title{
    display: inline-block;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 12px;
  }
}
.result_area{
  margin-top: 20px;
}
.item_tag{
  margin:10px 14px 4px 0;
  background: #EFEFEF 50%;
  color: #4F4F4F;
  border:none;
  position: relative;

}
::v-deep .result_area .el-tag__close.el-icon-close{
  position: absolute;
  top: -8px;
  right: -8px;
  background: #BD3124;
}
::v-deep .el-select .el-tag__close.el-icon-close{
  top: -2px;
}
::v-deep .choose_distribute .el-input__inner{
  width: 100%;
}
::v-deep .item_tag.active-class{
  border: 1px solid #0052D9;
}
::v-deep .custom-select .el-tag {
  display: inline-block;
  //max-width: 130px; /* 根据需要调整宽度 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::v-deep .el-select.custom-select{
  width: 100%;
}
::v-deep .custom-select .el-tag + .el-tag {
  margin-left: 6px; /* 调整标签之间的间距 */
}
::v-deep .custom-select .el-tag:nth-child(n+3) {
  display: none; /* 隐藏第三个及以后的标签 */
}
::v-deep .custom-select .el-tag:nth-child(2) {
  margin-right: 4px; /* 在第二个标签后留出一些空间 */
}
//::v-deep  .custom-select .el-tag:nth-child(2)::after {
//  content: "+";
//  margin-left: 4px;
//}
::v-deep .el-cascader.el-cascader .el-input .el-input__inner{
  width: 100%;
}
.result_area{
  margin-top: 20px;
  border-radius: 5px;
  padding: 14px 12px;
  background-color: rgba(255,255,255,1);
  border: 1px solid rgba(239,239,239,1);
  .tag_list{
    max-height: 300px;
    overflow: auto;
  }
}
::v-deep .result_area .el-input__inner{
  width: 100%!important;
}
</style>